export var SCREENTABS_VALIDATION_ERROR = 'SCREENTABS_VALIDATION_FAILED';
export var FIELD_VALIDATION_ERROR = 'FIELD_VALIDATION_FAILED';
export var APPLY_CHANGES_FOR_UNREGISTERED_FIELD = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
export var MULTIPLE_APPS_CONFLICT = 'MULTIPLE_APPS_CONFLICT';
export var MULTIPLE_APPS_CONFLICT_CAUSE_FIELD = 'FIELD';
export var MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS = 'SCREENTABS';